import { render, staticRenderFns } from "./purchaseTaskTable.vue?vue&type=template&id=05100777&scoped=true&"
import script from "./purchaseTaskTable.vue?vue&type=script&lang=js&"
export * from "./purchaseTaskTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05100777",
  null
  
)

export default component.exports